<template>
  <layout name="LayoutDefault">
    <!-- Page Content -->
    <div class="container">
      <div class="row slider">
        <div class="col-md-12">
          <div
            id="sliderCarousel"
            class="carousel slide bg-white home-banner"
            data-ride="carousel"
          >
            <ol class="carousel-indicators">
              <li
                data-target="#sliderCarousel"
                v-for="(item, index) in banner"
                v-bind:class="{ active: index === 0 }"
                :data-slide-to="`${index}`"
                v-bind:key="index"
              ></li>
            </ol>
            <div class="carousel-inner">
              <div
                v-bind:key="index"
                v-for="(item, index) in banner"
                v-bind:class="{ 'carousel-item': true, active: index === 0 }"
              >
              <component :is="item.short_description ? 'a' : 'div'" :href="item.short_description ? `${baseUrl}book/${item.short_description}` : null">
                <!-- <a :href="`${baseUrl}book/${item.custom_field}`"> -->
                  <vue-load-image>
                    <img
                      slot="image"
                      v-bind:src="`${IMAGEURL}${item.image}`"
                      alt="Image"
                      style="max-width: 100%"
                    />
                    <img
                      slot="preloader"
                      v-bind:src="`${baseUrl}/assets/img/loader.gif`"
                      title="Image Loading..."
                    />
                    <div slot="error">can't load image</div>
                  </vue-load-image>
                </component>
                <!-- </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Page Features -->
      <div class="body-section">
        <div
          v-for="(section, skey) in sectionProducts"
          v-bind:key="skey"
          class="row mb-4"
        >
          <div class="col-lg-12">
            <div class="section-column">
              <div class="section-header d-flex justify-content-between">
                <h2>
                  {{ section.title }}
                </h2>
                <div>
                  <a
                    :href="`${baseUrl}section/${section.id}/${section.slug}`"
                    class="more-link float-right mt-2 position-relative"
                    ><img src="/assets/img/arrow-right.png"
                  /></a>
                </div>
              </div>

              <div class="section-items">
                <div class="row">
                  <div
                    v-for="(item, k) in section.products"
                    v-bind:key="k"
                    class="col-lg-2 col-sm-6 col-6"
                  >
                    <div class="section-item books">
                      <span v-if="item.badge" class="badgeText">{{ item.badge }}</span>
                      <div v-if="item.discount > 0" class="discount-badge">
                        <span>{{ item.discount }}</span>
                        <span v-if="item.discount_type == 'Percent'">%</span>
                        <span v-else class="taka-off">Tk.</span>
                        <div>OFF</div>
                      </div>
                      <a :href="`${baseUrl}book/${item.id}`">
                        <ProductImage :image="item.image" />
                        <h4 v-if="item.product_name.length < 15"
                        >
                          {{ item.product_name }}
                        </h4>
                        <h4 
                          v-if="item.product_name.length >= 15"
                          :title="`${item.product_name}`"
                        >
                          {{ item.product_name.substr(0, 15) + "..." }}
                        </h4>
                      </a>
                      <span
                        v-for="(author, index) in item.authors"
                        v-bind:key="index"
                      >
                        <a :href="`${baseUrl}author/${author.author_id}`">{{
                          author.author_name
                        }}</a>
                        <span v-if="index + 1 < item.authors.length">, </span>
                      </span>
                      <div class="item-price">
                        <div v-if="item.discount > 0" class="item-price">
                          Price: Tk. {{ item.price }}
                        </div>
                        <div class="item-regular-price">
                          Regular Price: Tk. {{ item.orginal_price }}
                        </div>
                      </div>
                      <ItemHoverButtons :item="item"/>
                      <!-- <div class="hover-item">
                        <div class="arrow-up"></div>
                        <a
                          href="javascript:;"
                          @click="addToCart(item)"
                          class="btn btn-primary add-to-cart btn-sm"
                          >Add to Cart</a
                        >
                        <a
                          :href="`${baseUrl}book/${item.id}`"
                          class="btn btn-black view-details btn-sm"
                          >View Details</a
                        >
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="!sectionLoading && sectionProducts.length < 1">
                Sorry but no product found.
              </div>
            </div>
          </div>
        </div>

        <div v-if="homeAd" class="row mb-5 home-footer-ad">
          <div
            v-for="(item, k) in homeAd"
            v-bind:key="k"
            class="col-12 col-sm-6 mt-3 mt-lg-0"
          >
            <a :href="`${item.short_description}`">
              <img
                v-bind:src="`${IMAGEURL}${item.image}`"
                alt=""
                class="w-100 rounded"
              />
            </a>
          </div>
        </div>
      </div>

      <!---------------------popup----------------->

      <!-- Modal -->
      <div
        class="modal fade modal-center"
        id="myModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content" style="border: 0px">
            <button
              class="close"
              data-dismiss="modal"
              style="position: absolute;right: 0;z-index: 4;border: 1px solid #aa4242;padding: 0px 8px;background: #aa4242;color: #fff;"
            >
              &times;
            </button>

            <div class="modal-body" style="padding: 0px">
              <img
                v-if="popup"
                v-bind:src="`${IMAGEURL}${popup.image}`"
                alt="Image"
                class="img-responsive"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.container -->
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import VueLoadImage from "vue-load-image";
import ProductImage from './common/ProductImage.vue';
import ItemHoverButtons from "./common/ItemHoverButtons.vue";

export default {
  name: `Home`,
  data() {
    return {
      sectionProducts: [],
      banner: [],
      popup: null,
      homeAd: null,
      sectionLoading: true,
    };
  },
  components: {
    Layout,
    ProductImage,
    ItemHoverButtons,
    "vue-load-image": VueLoadImage,
  },
  methods: {
    // addToCart(row) {
    //   let itemObj = {
    //     session_id: localStorage.getItem("session_id"),
    //     product_id: row.id,
    //     image: row.image,
    //     price: row.price,
    //     quantity: 1,
    //     name: row.product_name,
    //   };
    //   this.$helper.saveToCart(itemObj);
    //   var cartCount = this.$helper.cartCount();
    //   $(".cart-count").text(cartCount);
    //   this.flashMessage.success({ message: "Added item to cart" });
    // },
    getHomeSections() {
      this.$http
        .get("home-sections")
        .then((response) => {
          this.sectionProducts = response.data;
          this.sectionLoading = false;
          console.log(response.data);
        })
        .catch((e) => {
          this.sectionProducts = [];
          this.sectionLoading = false;
        });
    },
    getBanner() {
      fetch(this.APIURL + "cms-resources/Banner-Slider")
        .then((response) => response.json())
        .then((json) => (this.banner = json.data))
        .catch(function (error) {
          console.log(error);
        });
    },
    getPopUp() {
      this.$http
        .get("cms-resources/Pop-Up")
        .then((response) => {
          this.popup = response.data.data[0];
          console.log(this.popup);
          if (this.popup.status == "Active") {
            $("#myModal").modal("show");
          }
        })
        .catch((e) => {
          this.popup = null;
        });
    },
    getAd() {
      this.$http
        .get("cms-resources/Home-Ad")
        .then((response) => {
          this.homeAd = response.data.data;
          console.log(response);
        })
        .catch((e) => {
          this.homeAd = null;
        });
    },
  },
  mounted() {
    this.getPopUp();
    this.getHomeSections();
    this.getBanner();
    this.getAd();
  },
};
</script>
